import Skeleton from 'react-loading-skeleton';
import MArrowRightUpIcon from '@/assets/manifold-icons/arrow-right-up.svg';
import { TELEMETRY_EVENT_MAP } from '@/common/telemetry';
import { generateCreateYourOwnLink } from '@/common/util';
import StyledButton from '@/components/StyledButton';
import { useAnalytics } from '@/hooks/useAnalytics';
import useMainStore from '@/store/mainStore';

export default function CreateYourOwnButton() {
  const studioInstance = useMainStore((state) => state.studioInstance);
  const analytics = useAnalytics();

  if (!studioInstance) {
    return (
      <div className="m-claim--mt-auto m-claim--pt-10">
        <Skeleton
          height={48}
          width={120}
        />
      </div>
    );
  }

  const link = generateCreateYourOwnLink(studioInstance);
  return (
    <div className="m-claim--mt-auto m-claim--pt-10">
      <StyledButton
        version="tertiary"
        className="m-claim--inline-flex m-claim--h-10 m-claim--items-center m-claim--justify-center m-claim--gap-2 m-claim--pb-1.5 m-claim--pl-3 m-claim--pr-2 m-claim--pt-2"
        style={{
          width: '180px',
        }}
        onClick={() => {
          analytics.capture({
            event: TELEMETRY_EVENT_MAP.CREATE_YOUR_OWN_BUTTON_CLICK,
          });
          window.open(link, '_blank');
        }}
      >
        <div className="m-claim--text-xs m-claim--font-normal">CREATE YOUR OWN</div>
        <img
          src={MArrowRightUpIcon}
          alt="Share Icon"
          width={20}
          height={20}
        />
      </StyledButton>
    </div>
  );
}
